import styled from 'styled-components';
import { animated } from 'react-spring';

// SB - SideBar
// HD - Header
// RT - Router

interface ContainerProps {
  isRetract: boolean;
}

export const Container = styled(animated.main) <ContainerProps>`
  min-height: 100vh;
  width: 100%;
  background: ${(props) => props.theme.backgroundPrivateLayout};
  padding-right: 1rem;
  display: grid;
  gap: 0.8rem 1.8rem;
  grid-template-rows: 5.5rem auto;
  grid-template-areas:
    'SB HD'
    'SB RT'
    'SB RT';

  > section {
    background: transparent;
    height: 100%;
  }
`;
